import type { OptionsPropType } from '@atlaskit/radio/types';
import { useIntl } from '@atlassian/jira-intl';
import { PORTAL_ACCESS, SHARE_REQUESTS_ACCESS } from '../../../../common/types';
import messages from './messages';
import type { FormContentProps } from './types';

export const usePortalAccessOptions = ({
	globalAccessType,
}: {
	globalAccessType: FormContentProps['globalAccessType'];
}): OptionsPropType => {
	const { formatMessage } = useIntl();

	return [
		{
			name: 'refer-to-customer-access',
			value: globalAccessType,
			label: formatMessage(messages.allowAccessBaseOnGlobalCustomerAccessSettingsOption),
		},
		{
			name: 'restricted-access',
			value: PORTAL_ACCESS.RESTRICTED,
			label: formatMessage(messages.restrictedAccessToAddedByAdminOrAgentOnly),
		},
	];
};

export const useShareRequestsOptions = (): OptionsPropType => {
	const { formatMessage } = useIntl();

	return [
		{
			name: 'share-req-agent-only',
			value: SHARE_REQUESTS_ACCESS.AGENT_ONLY,
			label: formatMessage(messages.shareRequestAgentonly),
		},
		{
			name: 'share-req-email-only',
			value: SHARE_REQUESTS_ACCESS.EMAIL_ONLY,
			label: formatMessage(messages.shareRequestEmailonly),
		},
		{
			name: 'share-req-auto-complete',
			value: SHARE_REQUESTS_ACCESS.SEARCH_AUTO_COMPLETE,
			label: formatMessage(messages.shareRequestSearchAutoComplete),
		},
	];
};
